import { render, staticRenderFns } from "./ProduitsApparentes.vue?vue&type=template&id=4d364bd4&scoped=true&"
import script from "./ProduitsApparentes.vue?vue&type=script&lang=js&"
export * from "./ProduitsApparentes.vue?vue&type=script&lang=js&"
import style0 from "./ProduitsApparentes.vue?vue&type=style&index=0&id=4d364bd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d364bd4",
  null
  
)

export default component.exports